<!-- Milestone - Display Rewards -->
<div *ngIf="results == undefined">
    <span>&nbsp;</span>
</div>

<div *ngIf="gs.selectedGame && gs.selectedGame[0] && (gs.selectedGame[0].underlyingRule.GameType == 6 || gs.selectedGame[0].underlyingRule.GameType == 7)">
    <div *ngIf="gs.selectedGame[0].Qualifier">
        <div *ngIf="params.data.passed">
            <span [ngbPopover]="connect3MetricsPopover" placement="left" triggers="outsideClick" container="body" class="color-cerulean" popoverClass="estimator-popover">{{params.value}}</span>
        </div>
        <div *ngIf="!params.data.passed">
            <span>{{params.value ? params.value: ''}}</span>
        </div>
    </div>
    <div *ngIf="(gs.selectedGame[0].Qualifier == null || gs.selectedGame[0].Qualifier == undefined) && (params.value != null || params.value != undefined)">
        <span [ngbPopover]="connect3MetricsPopover" placement="left" triggers="outsideClick" container="body" class="color-cerulean" popoverClass="estimator-popover">{{params.value}}</span>
    </div>
</div>

<div *ngIf="gs.selectedGame && gs.selectedGame[0] && gs.selectedGame[0].underlyingRule.GameType == 5">
    <div *ngIf="gs.selectedGame[0].Qualifier">
        <div *ngIf="params.data.passed">
            <ng-container *ngTemplateOutlet="milestoneResults"></ng-container>
        </div>
        <div *ngIf="!params.data.passed">
            <span>{{params.value ? params.value : ''}}</span>
        </div>
    </div>
    <div *ngIf="(gs.selectedGame[0].Qualifier == null || gs.selectedGame[0].Qualifier == undefined) && (params.value != null || params.value != undefined)">
        <ng-container *ngTemplateOutlet="milestoneResults"></ng-container>
    </div>
</div>

<div *ngIf="gs.selectedGame && gs.selectedGame[0] && gs.selectedGame[0].underlyingRule.GameType != 5 && gs.selectedGame[0].underlyingRule.GameType != 6 && gs.selectedGame[0].underlyingRule.GameType != 7">
    <span>{{params.value ? params.value : ''}}</span>
</div>


<!-- TEMPLATES -->
<ng-template #milestoneResults>
    <div class="row p-2" style="min-width: 200px;">
        <div class="container-fluid p-0">
            <div class="MainContainer">
                <div class="map_container" (ngStyle)="getThemeBackground()" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/Background.svg');height: 185px;"></div>
                <div class="map_item" *ngIf="showMilestone(0)" (ngStyle)="getMilestoneImage(0)" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/check1.svg');height: 185px;"></div>
                <div class="map_item" *ngIf="showMilestone(1)" (ngStyle)="getMilestoneImage(1)" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/check2.svg');height: 185px;"></div>
                <div class="map_item" *ngIf="showMilestone(2)" (ngStyle)="getMilestoneImage(2)" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/check3.svg');height: 185px;"></div>
                <div class="map_item" *ngIf="showMilestone(3)" (ngStyle)="getMilestoneImage(3)" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/check4.svg');height: 185px;"></div>
                <div class="map_item" *ngIf="showMilestone(4)" (ngStyle)="getMilestoneImage(4)" style="background-image:url('../../../../../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/space/check5.svg');height: 185px;"></div>
            </div>
            <div class="row">
                <div class="col-sm-12 pt-2">
                    <span class="color-valyrianSteel font-size-14 pl-3 pr-3" cvLocalizedText langSection="Games" langKey="Reward_Breakdown">Reward Breakdown</span>
                </div>
            </div>
            <!-- Reference commented out since it is not yet correctly implemented -->
            <!-- <cv-reward-details [gameData]="gs.selectedGame[0]" [gameRanking]="params.data.MetricData" class="pt-2"></cv-reward-details> -->
        </div>
    </div>
</ng-template>

<!-- Connect3/Connect All - Display Metrics -->
<ng-template #connect3MetricsPopover>
    <div class="row p-2" style="max-width: 220px;">
        <div class="col-4 px-2" *ngFor="let metricPosition of gs.modified.item.Connect3Positions">
            <div class="card p-1 mx-n1 my-1 text-center font-size-10" style="height:60px"
                [ngClass]="participant.connect3Metrics[metricPosition.position].metricCompleted ? (participant.MetricData.Rule.GameType == 6 ? 'cardCompleted': 'cardCompletedBlackout') : (participant.MetricData.Rule.GameType == 6 ? 'cardConfiguredConnect3': 'cardConfiguredBlackout')">
                <div *ngIf="participant.connect3Metrics[metricPosition.position].metricCompleted" class="d-flex flex-row-reverse">
                    <div class="icon-12" [ngClass]="participant.MetricData.Rule.GameType == 6 ? 'checkMarkConnect3': 'checkMarkBlackout'"></div>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <div class="metric-container">
                        <div *ngIf="metricPosition.metric == null">
                            <svg class="icon-12 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                        </div>
                        <div class="font-size-10">{{(metricPosition.metric ==  null ? getLocalizedText("Metric_Goal", "Metric Goal") : metricPosition.metric.abbrev)}}</div>
                        <div *ngIf="metricPosition.targetObj.Target != null" class="font-size-10">
                            {{(metricPosition.metric.direction === "0") ? "<" : ">"}} {{getFormattedMetric(metricPosition.targetObj.Target, metricPosition.metric.conversionType)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>